'use client'
import  './headerDropdown.scss'
import {useEffect, useRef, useState} from "react";
import {Link, useParams} from "react-router-dom";
import {getPropsFromState} from "../../redux/mapStateToProps";
import {ChangeLanguage} from "../../redux/actions";
import {connect} from "react-redux";
import {CollapseLangIcon} from "../../assets/images";
import {getUrlWithLocal} from "../../utils/getUrlWithLocal";


 function HeaderDropDown (props) {
    const {title,options,link,isAbout,isActive,staticTexts} = props
    const [openDropdown, setOpenDropdown] = useState(false)
    const params = useParams()
    const dropDownRef = useRef();

    useEffect(() => {
        if (openDropdown) {
            window.addEventListener('click', onClickedOutSide, true)
            window.addEventListener('scroll', onClickedOutSide, true)
        } else {
            window.removeEventListener('click', onClickedOutSide, false)
            window.removeEventListener('scroll', onClickedOutSide, false)
        }
        return () => {
            window.removeEventListener('click', onClickedOutSide, true)
            window.removeEventListener('scroll', onClickedOutSide, true)
        }
    }, [openDropdown]);

    function onClickedOutSide(event) {
        const path = event.composedPath ? event.composedPath() : event.path;
        if (!path?.includes(dropDownRef?.current)) {
            setOpenDropdown(false)
        }
    }


    return (
        !link ? <div className={'headerDropdown_wrapper'}
                     onMouseOver={() => setOpenDropdown(true)}
                     onMouseOut={() => setOpenDropdown(false)}
                     ref={dropDownRef}>
            <Link to={getUrlWithLocal('/works/all')} className={`headerDropdown_title 
            ${openDropdown ? 'headerDropdown_active' : '' } 
            ${params?.pathname?.includes(isActive) ? 'headerDropdown_active' : ''} `
                } >
                {title}
                {
                    openDropdown  ?  <CollapseLangIcon/> :  <CollapseLangIcon/>
                }
            </Link>
            {
                <div className={`options_wrapper
                 ${openDropdown ? 'open_options' : ''}`}>
                    {
                        options?.length && options.map((item, index) => {
                            return <Link to={getUrlWithLocal(item?.link)} className={'options_item'} key={index} onClick={() => setOpenDropdown(false)}>
                                {item?.title}
                            </Link>
                        })
                    }
                </div>
            }
        </div> : <Link to={getUrlWithLocal(link)}
                       className={`header_link ${params?.pathname?.includes(isActive) ? 'header_active' : ''} `}>
            {title}
        </Link>
    )
}
const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'languages',
        'staticTexts',
        'contact',
        'selectedLanguage',
    ])
};

const mapDispatchToProps = {
    ChangeLanguage
};

export default connect(mapStateToProps, mapDispatchToProps)(HeaderDropDown);
